import { Card, LinearProgress, Table, TableBody, TableContainer, TableRow } from "@mui/material";
import { useMemo } from "react";
import { HeaderGroup, Row, useGlobalFilter, usePagination, useSortBy, useTable } from "react-table";
import { IBulkAction } from "../DataTable/BulkAction";
import { DataTableMockData } from "../DataTable/Data/DataTableMockData";
import { DataTableBodyCell } from "../DataTable/DataTableBodyCell";
import { DataTableHeadCell } from "../DataTable/DataTableHeadCell";
import { MDBox } from "../MDBox";
import { MDButton } from "../MDButton";
import { tableHeaderColour } from '../BEE123.Constants';
import { BasicDataTableHeadCell } from "./BasicDataTableHeadCell";

interface IDataTableProps {
    table?: any;
    isLoading?: boolean;
    bulkActions?: IBulkAction[];
  }
  
  export const BasicDataTable: React.FC<IDataTableProps> = ({
    table = DataTableMockData,
    isLoading = false,
    bulkActions = [],
  }: IDataTableProps) => {
  

    const columns = useMemo(() => table.columns, [table]);
    const data = useMemo(() => table.rows, [table]);
  
    const tableInstance = useTable(
      { columns, data, initialState: { pageIndex: 0 } as any },
      useGlobalFilter,
      useSortBy,
      usePagination
    );
  
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      rows,
      page
    } = tableInstance;
    
    return (
      <MDBox>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <MDBox display="flex">
            {bulkActions.map(function (bulkAction, i) {
              return (
                <MDButton variant="gradient" color="info" sx={{ mr: 2 }} onClick={() => bulkAction.action()}>
                  {bulkAction.label}
                </MDButton>
              )
            })}
          </MDBox>
        </MDBox>
        <Card>
          <MDBox>
            <TableContainer sx={{ boxShadow: 'none' , borderRadius: '0rem'}}>
              { isLoading ? <LinearProgress color='info' /> : null}
              <Table {...getTableProps()}>
                <MDBox component='thead'>
                  {headerGroups.map((headerGroup) => (
                    <TableRow {...headerGroup.getHeaderGroupProps()} sx={{ backgroundColor: tableHeaderColour,  marginBottom: '0px' }}>
                      {headerGroup.headers.map((column) => (
                        <BasicDataTableHeadCell
                          {...column.getHeaderProps()}
                          width={column.width ? column.width : 'auto'}
                        //   sorted={setSortedValue(column)}
                        >
                          {column.render('Header')}
                        </BasicDataTableHeadCell>
                      ))}
                    </TableRow>
                  ))}
                </MDBox>
                <TableBody {...getTableBodyProps()} >
                  {page.map((row: Row<any>, key: number) => {
                    prepareRow(row);
                    return (
                      <TableRow {...row.getRowProps()} >
                        {row.cells.map((cell) => (
                          <DataTableBodyCell
                            noBorder={false}
                            {...cell.getCellProps()}
                          >
                            {cell.render('Cell')}
                          </DataTableBodyCell>
                        ))}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </MDBox>
        </Card>
      </MDBox >
    );
  }
  